import React from 'react'
import PropTypes from 'prop-types'
import {
    Text,
    Box,
    Button,
    HStack,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverBody,
    PopoverCloseButton
} from '@salesforce/retail-react-app/app/components/shared/ui'

export const PLPStoryTermsAndConditions = ({
    desktopTcPosition = 'bottom-right',
    mobileTcPosition = 'bottom-right',

    termsAndConditionsLabel,
    termsAndConditionsLabelFontFamily = 'caslon',
    termsAndConditionsLabelColor = 'black',

    termsAndConditionsTitleText,
    termsAndConditionsFontFamily,
    termsAndConditionsTag,
    termsAndConditionsTitleBody
}) => {
    return (
        termsAndConditionsLabel && (
            <Box
                left={{
                    base: mobileTcPosition === 'bottom-left' ? '15px' : 'initial',
                    lg: desktopTcPosition === 'bottom-left' ? '15px' : 'initial'
                }}
                right={{
                    base: mobileTcPosition === 'bottom-right' ? '15px' : 'initial',
                    lg: desktopTcPosition === 'bottom-right' ? '15px' : 'initial'
                }}
                position="absolute"
                bottom={{base: '10px', lg: '15px'}}
            >
                <Popover placement="top-start">
                    {({isOpen}) => (
                        <>
                            <PopoverTrigger>
                                <Button
                                    variant="unstyled"
                                    height="auto"
                                    padding="0"
                                    zIndex="1"
                                    lineHeight="normal"
                                >
                                    <Text
                                        as="span"
                                        fontFamily={termsAndConditionsLabelFontFamily}
                                        color={termsAndConditionsLabelColor}
                                        fontSize={{base: '14px', lg: '16px'}}
                                        letterSpacing={{base: '0.09px', lg: '0.12px'}}
                                        lineHeight="18px"
                                        fontWeight="400"
                                    >
                                        {termsAndConditionsLabel}
                                    </Text>
                                </Button>
                            </PopoverTrigger>

                            <PopoverContent
                                paddingX="15px"
                                paddingY="10px"
                                border="1px solid"
                                borderColor="gray.600"
                                borderRadius="0"
                                display={isOpen ? 'block' : 'none'}
                            >
                                <HStack
                                    position="relative"
                                    alignItems="start"
                                    justifyContent="space-between"
                                    padding="0"
                                    gap="10px"
                                    marginBottom="10px"
                                >
                                    {termsAndConditionsTitleText && (
                                        <PopoverHeader padding="0">
                                            <Text
                                                as={termsAndConditionsTag}
                                                fontFamily={termsAndConditionsFontFamily}
                                                color="black.300"
                                                fontSize="10px"
                                                fontWeight="700"
                                                lineHeight="17px"
                                                letterSpacing="0.05px"
                                            >
                                                {termsAndConditionsTitleText}
                                            </Text>
                                        </PopoverHeader>
                                    )}
                                    <PopoverCloseButton color="black.300" right="0" />
                                </HStack>

                                {termsAndConditionsTitleBody && (
                                    <PopoverBody padding="0">
                                        <Box
                                            dangerouslySetInnerHTML={{
                                                __html: termsAndConditionsTitleBody
                                            }}
                                            color="black.300"
                                            fontSize="10px"
                                            fontWeight="400"
                                            lineHeight="17px"
                                            letterSpacing="0.05px"
                                            fontStyle="italic"
                                            sx={{
                                                p: {
                                                    fontSize: '10px',
                                                    fontWeight: '400',
                                                    lineHeight: '17px',
                                                    letterSpacing: '0.05px',
                                                    fontStyle: 'italic'
                                                }
                                            }}
                                        />
                                    </PopoverBody>
                                )}
                            </PopoverContent>
                        </>
                    )}
                </Popover>
            </Box>
        )
    )
}

PLPStoryTermsAndConditions.propTypes = {
    desktopTcPosition: PropTypes.string,
    mobileTcPosition: PropTypes.string,

    termsAndConditionsLabel: PropTypes.string,
    termsAndConditionsLabelFontFamily: PropTypes.string,
    termsAndConditionsLabelColor: PropTypes.string,
    titleTag: PropTypes.string,

    termsAndConditionsTitleText: PropTypes.string,
    termsAndConditionsFontFamily: PropTypes.string,
    termsAndConditionsTag: PropTypes.string,
    termsAndConditionsTitleBody: PropTypes.string
}

export default PLPStoryTermsAndConditions
